<button mat-stroked-button
        class="wide-button"
        [class.full-width]="fullWidth()"
        [matMenuTriggerFor]="langMenu">
  <mat-icon class="select-icon" iconPositionEnd>expand_more</mat-icon>
  {{ 'langs.' + translateService.currentLang | translate }}
</button>

<mat-menu #langMenu="matMenu">
  @for (lang of allLanguages; track $index) {
    <button mat-menu-item
            [disabled]="previewMode$ | async"
            (click)="onSetLang(lang)">{{ 'langs.' + lang | translate }}
    </button>
  }
</mat-menu>
